import { render, staticRenderFns } from "./layout-header.vue?vue&type=template&id=4e782d2b&"
import script from "./layout-header.vue?vue&type=script&lang=js&"
export * from "./layout-header.vue?vue&type=script&lang=js&"
import style0 from "./layout-header.vue?vue&type=style&index=0&id=4e782d2b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports